import type { FilterData, SelectedNbfFilters } from '@which/shared'

import type { Filter, NeedsBasedFilter } from '../../../../generated/frontend'
import {
  getActiveNeedsBasedFilters,
  mapAppliedFilterItems,
} from '../components/AppliedFilters/AppliedFilters.utils'

export const getSelectedFilters = ({
  basicFilters,
  basicFilterData,
  selectedNeedsBasedFilters,
  needsBasedFilters,
  needsBasedFilterData,
}: {
  basicFilters?: Filter[]
  basicFilterData?: FilterData
  selectedNeedsBasedFilters?: SelectedNbfFilters
  needsBasedFilters?: NeedsBasedFilter[]
  needsBasedFilterData?: FilterData
}) => {
  if (basicFilterData && needsBasedFilters) {
    const externalIds = Object.keys(basicFilterData)

    const activeNeedsBasedFilters = getActiveNeedsBasedFilters({
      needsBasedFilters,
      selectedNeedsBasedFilters,
      needsBasedFilterData,
    })

    const activeBasicFilters =
      basicFilters?.filter((filter) =>
        externalIds.includes(filter.externalId)
      ) /*v8 ignore next*/ || []

    const activeFilters = [...activeNeedsBasedFilters, ...activeBasicFilters]

    return activeFilters?.flatMap((activeFilter) =>
      mapAppliedFilterItems({ activeFilter, basicFilterData })
    )
  }
}
